import { useState } from "react";

import { tenant } from "@tenant";

import { default as Button } from "antd/es/button";
import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "./cookieConsent";
import { CookieIcon } from "./icons/CookieIcon";

export { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "./cookieConsent";

export function CookieBanner({
  showRejection = false,
  onAcceptCookies,
  onRejectCookies,
}: {
  showRejection?: boolean;
  onAcceptCookies?: () => void;
  onRejectCookies?: () => void;
}) {
  const [showBanner, setShowBanner] = useState(
    !localStorage.getItem(COOKIE_CONSENT_KEY),
  );

  const handleAcceptCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES.Accepted);
    setShowBanner(false);
    onAcceptCookies?.();
  };

  const handleRejectCookies = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES.Rejected);
    setShowBanner(false);
    onRejectCookies?.();
  };

  if (showBanner === false) return null;

  return (
    <div
      id="cookie-banner"
      className="m-6 flex flex-col flex-wrap items-center justify-center gap-4 rounded-2xl bg-surface-faint p-6 text-content-secondary lg:flex-nowrap lg:justify-between border border-border-muted dark:bg-black dark:text-white bg-white shadow-lg"
      data-testid="cookie-banner"
    >
      <div className="flex items-center gap-4">
        <CookieIcon width={55} height={55} className="w-1/4" stroke="#004B4B" />
        {showRejection ? (
          <p>
            Our website uses strictly necessary cookies for basic functionality.
            We also use optional tracking cookies to enhance your experience and
            analyze website usage. You can opt out of tracking cookies while
            still using our website with essential cookies only.{" "}
            <a
              className="text-tenant-primary"
              href={tenant.urls.privacyPolicy}
              data-testid="cookie_banner_privacy-notice-link"
            >
              Privacy notice
            </a>
          </p>
        ) : (
          <p>
            Our website uses cookies to enhance your experience. By continuing
            to use our website, you agree to our use of cookies. You cannot
            proceed without accepting cookies.
          </p>
        )}
      </div>
      <div className="flex justify-between gap-2 whitespace-nowrap w-full">
        {showRejection && (
          <Button
            className="w-full font-medium"
            value="Reject"
            size="large"
            onClick={handleRejectCookies}
            type="default"
            data-testid="cookie-banner-reject-button"
          >
            Reject
          </Button>
        )}
        <Button
          className="w-full font-medium"
          value="Submit"
          type="primary"
          size="large"
          data-testid="cookie-banner-accept-button"
          onClick={handleAcceptCookies}
        >
          Accept
        </Button>
      </div>
    </div>
  );
}
